import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/createSuper";
var _excluded = ["name", "size", "theme", "title", "id", "className"];
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import * as React from 'react';
import clsx from 'clsx';
import loadVector from './helpers';
var styles = {
  "root": "Svg-root_3izI7",
  "size-2x": "Svg-size-2x_1MPub",
  "size-3x": "Svg-size-3x_gRjOt",
  "size-4x": "Svg-size-4x__u1AO",
  "size-5x": "Svg-size-5x_1f6t4"
};
var sharedStyles = {
  "root": "SVG-root_1gLEH",
  "fill-white": "SVG-fill-white_1ifIm",
  "fill-green": "SVG-fill-green_3XEHx",
  "fill-blue": "SVG-fill-blue_3XxuW",
  "fill-grey-lighter": "SVG-fill-grey-lighter_ZsArp",
  "fill-grey-light": "SVG-fill-grey-light_2xlhv",
  "fill-grey": "SVG-fill-grey_BVkZ6",
  "fill-grey-dark": "SVG-fill-grey-dark_BCV7H",
  "fill-grey-darker": "SVG-fill-grey-darker_24g8W",
  "fill-anthracite": "SVG-fill-anthracite_7Va6z",
  "fill-yellow": "SVG-fill-yellow_1DmnQ",
  "fill-yellow-dark": "SVG-fill-yellow-dark_oJJ2l",
  "fill-yellow-darker": "SVG-fill-yellow-darker_3Tu8T",
  "fill-red": "SVG-fill-red_1zjVE",
  "fill-info": "SVG-fill-info_dJHzJ",
  "fill-success": "SVG-fill-success_2sUEP",
  "fill-warning": "SVG-fill-warning_3l7NA",
  "fill-danger": "SVG-fill-danger_3h58E",
  "fill-progress": "SVG-fill-progress_1wmR1 SVG-fill-info_dJHzJ",
  "fill-unknown": "SVG-fill-unknown_cu2te SVG-fill-grey-dark_BCV7H",
  "fill-disabled": "SVG-fill-disabled_2Wv9a SVG-fill-grey_BVkZ6"
};
var Svg = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Svg, _React$PureComponent);
  var _super = _createSuper(Svg);
  function Svg() {
    _classCallCheck(this, Svg);
    return _super.apply(this, arguments);
  }
  _createClass(Svg, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        size = _this$props.size,
        theme = _this$props.theme,
        title = _this$props.title,
        id = _this$props.id,
        className = _this$props.className,
        extra = _objectWithoutProperties(_this$props, _excluded);
      var Vector = loadVector(name);
      if (!Vector) {
        if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('No available Svg vector with name %s', name);
        }
        return null;
      }
      var rootClasses = clsx('Svg', "Svg-".concat(name), styles.root, size && styles["size-".concat(size)], theme && sharedStyles["fill-".concat(theme)], className);

      /**
       * a11y
       * If a `title` is provided, add needed props.
       * Else, hide the SVG from screen-readers.
       */
      /* eslint-disable prefer-object-spread */
      // $FlowFixMe[prop-missing]
      var extraProps = _Object$assign({}, title && id ? {
        'aria-labelledby': id,
        role: 'img',
        title: /*#__PURE__*/React.createElement("title", {
          id: id
        }, title)
      } : {
        'aria-hidden': 'true'
      }, extra);
      Vector.displayName = 'Vector';
      return /*#__PURE__*/React.createElement(Vector, _extends({
        className: rootClasses
      }, extraProps));
    }
  }]);
  return Svg;
}(React.PureComponent);
/**
 * Static assertion helper.
 * Test whether an SVG exist for `name`.
 */
Svg.has = function (name) {
  return !!loadVector(name);
};
export default Svg;